import { toast } from "react-toastify";
import { getSizesData, validateOneTimeBanner } from "../../services/apis";

export const useEditorBannerMeta = ({
  bannerId,
  oneTimeValidationDocRef,
  setIsOneTimeAsset,
  setSelectedSizeOptions,
  setSelectedBannerSize,
}) => {
  const fetchAllSizesBanner = (docNumber) => {
    getSizesData(docNumber, (response) => {
      if (response.status === 200) {
        let array = [];
        if (response?.data) {
          for (const key in response.data) {
            const element = response.data[key]
              .split("×")
              .map((item) => Number(item))
              .reverse()
              .join("×");
            array.push({ label: element, value: key });
          }
          setSelectedSizeOptions(array);
          localStorage.setItem("allBannersForVeevaId", JSON.stringify(array || []));
          setSelectedBannerSize(array.find((item) => item.value === bannerId).value);
        } else {
          setSelectedSizeOptions(array);
        }
      } else {
        toast.error(
          "Failed to fetch available banner sizes for current Veeva Document Number.",
        );
      }
    });
  };

  const fetchOneTimeAssetStatus = (damDocNumber, fallbackOneTimeAsset = false) => {
    if (!damDocNumber) {
      oneTimeValidationDocRef.current = "";
      window.localStorage.removeItem("oneTimeAsset");
      setIsOneTimeAsset(false);
      return;
    }

    if (oneTimeValidationDocRef.current === damDocNumber) {
      setIsOneTimeAsset(true);
      return;
    }

    validateOneTimeBanner(damDocNumber, (response, err) => {
      if (err) {
        oneTimeValidationDocRef.current = "";
        const safeFallback = Boolean(fallbackOneTimeAsset);
        window.localStorage.setItem("oneTimeAsset", JSON.stringify(safeFallback));
        setIsOneTimeAsset(safeFallback);
        return;
      }

      const oneTimeAsset = Boolean(response?.data?.oneTimeAsset);
      window.localStorage.setItem("oneTimeAsset", JSON.stringify(oneTimeAsset));
      oneTimeValidationDocRef.current = oneTimeAsset ? damDocNumber : "";
      setIsOneTimeAsset(oneTimeAsset);
    });
  };

  return {
    fetchAllSizesBanner,
    fetchOneTimeAssetStatus,
  };
};
